import { DateObj, DateTimeObj } from '../../universal';
import { _, momentJSRaw } from '../lib';
export function moment(inp, formatOrStrict, languageOrStrict, strict) {
    if (inp instanceof DateObj || inp instanceof DateTimeObj) {
        return momentJSRaw(inp.raw);
    }
    if (_.isBoolean(formatOrStrict)) {
        return momentJSRaw(inp, formatOrStrict);
    }
    if (_.isBoolean(languageOrStrict)) {
        return momentJSRaw(inp, formatOrStrict, languageOrStrict);
    }
    return momentJSRaw(inp, formatOrStrict, languageOrStrict, strict);
}
//# sourceMappingURL=moment-wrapper.js.map